export default __webpack_public_path__ + "static/media/mixedSpices.bdfefd15.jpeg";